/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function AddGatewayController($scope, $mdDialog, $state, $stateParams, $document, $q, $translate, types, gatewayService, gatewayModelService, gatewayGroupService, entityTableConfiguration) {

    var vm = this;

    vm.$onInit = function () {
        vm.entityTableConfiguration = entityTableConfiguration;

        vm.entity = {};

        vm.entityType = vm.entityTableConfiguration.entityType;
        vm.translations = types.entityTypeTranslations[vm.entityType];

        vm.add = add;
        vm.cancel = cancel;
    };

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        if ($stateParams.gatewayGroupId) {
            vm.entity.gatewayGroupId = {
                entityType: types.entityType.gateway_group,
                id: $stateParams.gatewayGroupId
            };
        }
        gatewayService.saveGateway(vm.entity).then(function success(entity) {
            vm.entity = entity;
            $scope.theForm.$setPristine();
            $mdDialog.hide();
            // After the Add modal closes, pop up a warning if this is an FSK gateway whose group has no
            // FSK Location configured yet — the FSK path won't work until a location is set.
            warnIfFskWithoutLocation(entity);
        });
    }

    function warnIfFskWithoutLocation(entity) {
        var groupId = entity && entity.gatewayGroupId ? entity.gatewayGroupId.id : $stateParams.gatewayGroupId;
        var modelId = entity && entity.gatewayModelId ? entity.gatewayModelId.id : null;
        if (!groupId || !modelId) {
            return;
        }
        $q.all({
            model: gatewayModelService.getGatewayModel(modelId),
            group: gatewayGroupService.getGatewayGroup(groupId)
        }).then(function (res) {
            var isFskModel = res.model && res.model.fsk;
            var hasLocation = res.group && res.group.fskLocationId;
            if (isFskModel && !hasLocation) {
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(false)
                        .title($translate.instant('gateway.fsk-location-warning-title'))
                        .textContent($translate.instant('gateway.fsk-location-warning'))
                        .ariaLabel($translate.instant('gateway.fsk-location-warning-title'))
                        .ok($translate.instant('action.ok'))
                );
            }
        }, angular.noop);
    }

}



// WEBPACK FOOTER //
// ./src/app/gateway/add-gateway.controller.js